import { render, staticRenderFns } from "./SEDocuments.vue?vue&type=template&id=065a2e66&"
import script from "./SEDocuments.vue?vue&type=script&lang=js&"
export * from "./SEDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports